module.exports = __webpack_public_path__ + "img/lqsx_1.6f9f12ad.svg";